import React from 'react'
import PropTypes from 'prop-types'

const MacroContainer = ({ children, className, dataTrackingName }) => {
  return (
    <div
      data-tracking-name={dataTrackingName}
      className={`macroContainer ${className}
        grid
        grid-cols-4 gap-16 mx-16
        600:grid-cols-8
        720:gap-24 720:mx-24
        840:grid-cols-12
        1000:gap-32 1000:mx-32
        1280:mx-auto 1280:max-w-1216
      `}
    >
      <div className="col-span-full 600:col-start-2 600:col-end-8 840:col-start-3 840:col-end-11">{children}</div>
    </div>
  )
}

MacroContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataTrackingName: PropTypes.string,
}

MacroContainer.defaultProps = {
  children: '',
  className: '',
}

export default MacroContainer
